<template>
  <div :id="'select-hcc'">
    <Select2
      v-model="selected"
      @select="select($event)"
      :settings="selectConfig"
      ref="select2"
      tabindex="0"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Select2 from 'v-select2-component'
  import config from '@/config.js'

  export default {
    name: 'HCCSelect',
    props: ['hccs'],
    components: {
      Select2
    },
    data(){
      return {
        hccsArr: this.hccs,
        selected: null
      }
    },
    mounted() {
      if (this.hccs){
        this.hccs.forEach(hcc => {
          this.$refs.select2.select2.append(
            `<option selected value="${hcc.id}">${hcc.shortname} (${hcc.code})</option>`
          )
        })
        this.$refs.select2.select2.trigger('change')
      }
    },
    computed: {
      ...mapState({
          userSettings: state => state.user.settings,
          userSettingsPI: state => state.user.settingsPI,
      }),
      selectConfig(){
        return {
          placeholder: "Select a HCC",
          allowClear: true,
          width: '100%',
          // dropdownParent: "#select-hcc" + this.idClass,
          minimumInputLength: 3,
          multiple: true,

          ajax: {
            delay: 1400,
            url: config.apiUrl + '/hccs/autocomplete',
            headers: config.apiHeaders,
            data: (params) => {
              const query = params.term;
              return {
                query: query,
                page: params.page || 1,
                preselected: this.hccsArr.map(x => x.id).join(',')
              }
            },
            processResults: (data) => {
              return {
                results: data.map(hcc => {
                  return {
                    id: hcc.id,
                    text: `${hcc.description} (${hcc.code})`,
                    hcc: hcc
                  }
                }),
                pagination: {
                  more: data.more
                }
              }
            }
          }
        }
      }
    },
    methods: {
      select(event){
        if (event.selected) {
          this.hccsArr.push(event.hcc)
        } else {
          this.hccsArr = this.hccsArr.filter(x => x.id !== event.id)
        }
      }
    }
  }
</script>

